import { render, staticRenderFns } from "./ValueFlow.vue?vue&type=template&id=5d6613b3"
import script from "./ValueFlow.vue?vue&type=script&lang=js"
export * from "./ValueFlow.vue?vue&type=script&lang=js"
import style0 from "./ValueFlow.vue?vue&type=style&index=0&id=5d6613b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports